(() => {
  const selector = '[data-srall-personalization], [id="srall-accessory-tote"], [id="srall-accessory-towel"]';
  const scope = box => box.closest('[data-section-type="product"], .product-section, product-info') || box.closest('form')?.parentElement;
  function selectedTitle(box, root) {
    const field = root.querySelector('[data-handle="personalization"], [data-handle="decoration"]');
    const selected = field?.querySelector('input:checked, select, a[aria-current="true"], a.hg-option-selected');
    if (selected) return selected.tagName === 'SELECT' ? selected.selectedOptions[0]?.textContent || '' : selected.value || selected.textContent;
    return box.dataset.selectedTitle || '';
  }
  function sync(box, override) {
    const root = scope(box);
    if (!root) return;
    const form = box.closest('form') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const title = String(override || selectedTitle(box, root)).toLowerCase();
    const textOn = /back text|\bname\b|custom (?:athletic )?text/.test(title);
    const numberOn = /number|jersey\s*#/.test(title);
    const textWrap = box.querySelector('[data-srall-text], [data-accessory-text]');
    const numberWrap = box.querySelector('[data-srall-number], [data-accessory-number]');
    for (const [wrap, on] of [[textWrap, textOn], [numberWrap, numberOn]]) {
      const input = wrap?.querySelector('input');
      if (!input) continue;
      wrap.hidden = !on;
      input.disabled = !on;
      input.required = on;
      const formId = form.getAttribute('id');
      if (formId) input.setAttribute('form', formId);
      else input.removeAttribute('form');
      if (!on) input.setCustomValidity('');
    }
    const note = box.querySelector('[data-srall-note]');
    if (note) note.hidden = !(textOn || numberOn);
    box.hidden = !(textOn || numberOn);
  }
  function scan(root = document) { root.querySelectorAll(selector).forEach(box => sync(box)); }
  function validate(form) {
    let valid = true;
    const root = form.closest('[data-section-type="product"], .product-section, product-info') || form.parentElement;
    root.querySelectorAll(selector).forEach(box => {
      sync(box);
      box.querySelectorAll('input:not(:disabled)').forEach(input => {
        input.value = input.value.trim();
        if (!input.value || !input.checkValidity()) {
          if (valid) { input.reportValidity(); input.focus(); }
          valid = false;
        }
      });
    });
    return valid;
  }
  document.addEventListener('change', event => {
    if (event.target.closest(selector)) return;
    const root = event.target.closest('[data-section-type="product"], .product-section, product-info');
    if (root) { scan(root); requestAnimationFrame(() => scan(root)); }
  }, true);
  document.addEventListener('variant:change', event => {
    const root = event.target.closest?.('[data-section-type="product"], .product-section, product-info') || document;
    root.querySelectorAll(selector).forEach(box => sync(box, event.detail?.variant?.title));
  });
  document.addEventListener('input', event => {
    const input = event.target;
    const box = input.closest(selector);
    if (!box || input.tagName !== 'INPUT') return;
    if (input.closest('[data-srall-number], [data-accessory-number]')) input.value = input.value.replace(/\D/g, '').slice(0, 3);
    else if (box.hasAttribute('data-srall-sleeve')) input.value = input.value.toUpperCase().slice(0, 20);
    input.setCustomValidity('');
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    if (!validate(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button[type="submit"], button[data-add-to-cart]');
    if (button?.form?.matches('form[action*="/cart/add"]') && !validate(button.form)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.(selector) || n.querySelector?.(selector))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => scan());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
})();

